import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';

export function getSearchResultsEmptyMessage(
  i18n: I18nFn,
  resultType: string,
  query: string | undefined,
  searchLocation: SearchLocation | undefined,
) {
  if (query) {
    if (searchLocation?.text) {
      /* TRANSLATORS: search: no results message */
      return i18n('"%(query)s" near %(searchLocationText)s', {
        query,
        searchLocationText: searchLocation.text,
      });
    }

    /* TRANSLATORS: search: no results message */
    return i18n('"%(query)s"', { query });
  }

  if (searchLocation?.text) {
    /* TRANSLATORS: search: no results message */
    return i18n('All %(resultType)s near %(searchLocationText)s', {
      resultType,
      searchLocationText: searchLocation.text,
    });
  }

  /* TRANSLATORS: search: no results message */
  return i18n('All %(resultType)s', { resultType });
}
